import React from "react";

// Compact inline SVG flags for language switcher
export function FlagIT({ size = 18 }) {
  return (
    <svg width={size} height={(size * 3) / 4} viewBox="0 0 30 20" aria-hidden="true">
      <rect width="10" height="20" fill="#009246" />
      <rect x="10" width="10" height="20" fill="#F1F2F1" />
      <rect x="20" width="10" height="20" fill="#CE2B37" />
    </svg>
  );
}

export function FlagEN({ size = 18 }) {
  // UK flag — used as international/English marker
  return (
    <svg width={size} height={(size * 3) / 4} viewBox="0 0 60 30" aria-hidden="true">
      <clipPath id="s">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id="t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath="url(#s)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}
